import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Info: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 27 26',
  cssHelper = Styling.fullHeightStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <Elements.G transform='translate(-30.000000, -94.000000)'>
          <Elements.G transform='translate(19.000000, 86.000000)'>
            <Elements.G transform='translate(12.000000, 9.000000)'>
              <Elements.G id='Icon/Information/White'>
                <Elements.Elipse
                  stroke={fill}
                  strokeWidth='2'
                  fillRule='nonzero'
                  cx='12.5'
                  cy='12'
                  rx='12.5'
                  ry='12'
                />
                <Elements.Polygon fill={fill} points='11 17 14 17 14 10.8461538 11 10.8461538' />
                <Elements.Polygon fill={fill} points='11 9.30769231 14 9.30769231 14 7 11 7' />
              </Elements.G>
            </Elements.G>
          </Elements.G>
        </Elements.G>
      </Elements.G>
    </Elements.Svg>
  );
};

export default Info;
